// extracted by mini-css-extract-plugin
module.exports = {"banda":"_DateType_banda_2tGB8","icon":"_DateType_icon_1BKYd","date":"_DateType_date_7bkst","title":"_DateType_title_-laZ1"};